(function () {
    'use strict';
    angular.module('app').controller('TrackingStatusModalController', TrackingStatusModalController);
    TrackingStatusModalController.$inject = [
        '$uibModalInstance'
    ];

    function TrackingStatusModalController(
        $uibModalInstance
    ) {
        const vm = this;

        vm.closeModal = closeModal;
        vm.setDeliveryDate = setDeliveryDate;

        function setDeliveryDate() {
            $uibModalInstance.close(vm.deliveryDate);
        }

        function closeModal() {
            $uibModalInstance.dismiss();
        }
    }
})();


// WEBPACK FOOTER //
// ./js/controllers/shipment/TrackingStatusModalController.js